import { render, staticRenderFns } from "./ModuloRecepcao.vue?vue&type=template&id=22de4baa&scoped=true&"
import script from "./ModuloRecepcao.vue?vue&type=script&lang=js&"
export * from "./ModuloRecepcao.vue?vue&type=script&lang=js&"
import style0 from "./ModuloRecepcao.vue?vue&type=style&index=0&id=22de4baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de4baa",
  null
  
)

export default component.exports